module.exports = __webpack_public_path__ + "static/media/atomic.fadf4962.png";